import { Sort } from '@angular/material/sort';
import { IMachineTotalJobs } from 'app/models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-department-total-jobs',
  templateUrl: './department.total.jobs.component.html',
  styleUrls: ['./department.total.jobs.component.scss'],
})
export class DepartmentTotalJobsComponent {
  @Input()
  departmentTotalJobsList: Array<IMachineTotalJobs> = [];

  columnsToDisplay: string[] = [
    'dateTimeWork',
    'fileName',
    'totalTimeAsHHmmss',
    'cutMetersAsString',
    'creaseMetersAsString',
    'average',
  ];

  sortData = (sort: Sort): void => {
    if (this.departmentTotalJobsList) {
      const data = this.departmentTotalJobsList.slice();
      if (!sort.active || sort.direction === '') {
        this.departmentTotalJobsList = data;
        return;
      }

      this.departmentTotalJobsList = data.sort(
        (a: IMachineTotalJobs, b: IMachineTotalJobs) => {
          const isAsc = sort.direction === 'asc';
          switch (sort.active) {
            case 'dateTimeWork':
              return this.compare(a.dateTimeWork, b.dateTimeWork, isAsc);
            case 'fileName':
              return this.compare(a.fileName, b.fileName, isAsc);
            default:
              return 0;
          }
        }
      );
    }
  };

  private compare = (a: string = '', b: string = '', isAsc: boolean): number =>
    (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
